import { useState, useEffect } from 'react';

const useCachedFetch = (url, options = {}) => {
    const { cacheDuration = 10 * 60 * 1000 } = options; // Default 10 minutes
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError(null);

            try {
                const cacheKey = `cache_${url}`;
                const cached = localStorage.getItem(cacheKey);

                if (cached) {
                    const { data: cachedData, timestamp } = JSON.parse(cached);
                    const now = Date.now();

                    if (now - timestamp < cacheDuration) {
                        console.log(`[useCachedFetch] Serving from cache: ${url}`);
                        setData(cachedData);
                        setLoading(false);
                        return;
                    }
                }

                console.log(`[useCachedFetch] Fetching from API: ${url}`);
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`Error fetching data: ${response.statusText}`);
                }
                const result = await response.json();

                localStorage.setItem(cacheKey, JSON.stringify({
                    data: result,
                    timestamp: Date.now()
                }));

                setData(result);
            } catch (err) {
                console.error(`[useCachedFetch] Error:`, err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [url, cacheDuration]);

    return { data, loading, error };
};

export default useCachedFetch;
